module.exports = __webpack_public_path__ + "img/del.edf82a6b.svg";